module.exports = __webpack_public_path__ + "img/kunshan_s.768fbb8.png";